import { cn } from "@/shared/helpers/cn.helper";

export const Table: React.FC<
  React.ComponentProps<"table"> & {
    afterChildren?: React.ReactNode;
    layout?: "auto" | "fixed";
    /** Merged onto the `<table>` element (wrapper `className` targets the scroll container). */
    nativeTableClassName?: string;
  }
> = ({
  className,
  nativeTableClassName,
  afterChildren,
  layout = "auto",
  ...props
}) => {
  const isFixed = layout === "fixed";
  return (
    <div className="relative flex min-h-0 flex-1 flex-col">
      <div
        className={cn(
          "flex-1",
          isFixed ? "overflow-y-auto overflow-x-hidden" : "overflow-auto",
          className,
        )}
      >
        <table
          className={cn(
            "w-full border-collapse",
            isFixed ? "min-w-0 table-fixed" : "min-w-max",
            nativeTableClassName,
          )}
          {...props}
        />
      </div>
      {afterChildren}
    </div>
  );
};
